export const works = [
  {
    id: "midnight-express",
    title: "深夜急行：沉默车厢",
    type: "movie",
    year: 2024,
    region: "日本",
    duration: "118 分钟",
    director: "佐野川润",
    cast: ["高梨淳", "森下绘里", "北村隆之"],
    genres: ["悬疑", "犯罪", "社会派"],
    rating: 8.6,
    heat: 9820,
    updatedAt: "2026-09-28",
    tagline: "当整节车厢都选择沉默，真相便成了唯一的乘客。",
    synopsis:
      "深夜急行末班车驶入隧道后，一名女乘客在拥挤车厢中遭遇骚扰却无人作证。刑警高梨淳接手调查，发现同一节车厢里的八名乘客，每个人都在隐瞒另一件事。",
    plot:
      "深夜十一点四十七分，开往郊外的急行列车驶入长隧道，车厢灯光短暂熄灭。灯亮之后，一名年轻女乘客向乘务员求助，称自己在拥挤中被骚扰，但整节车厢里没有人愿意站出来作证。案件因为证据不足几乎被搁置，刑警高梨淳却注意到一个细节：八名乘客的证词在时间点上出现了高度一致的偏差。\n\n随着调查推进，高梨淳发现这节车厢里的每一个人都与三年前一起未公开的列车事故有关。有人在逃避责任，有人在等待复仇，也有人只是想保护自己即将破碎的生活。当列车再次驶入那条隧道，高梨淳决定重现当晚的每一个站姿与每一次转身，逼迫沉默者开口。\n\n影片以冷静克制的镜头语言讨论公共空间中的旁观与共谋，最后二十分钟的车厢对峙戏几乎一镜到底，将整部作品的张力推到顶点。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20artwork%2C%20empty%20night%20express%20subway%20carriage%20lit%20by%20deep%20crimson%20emergency%20lamps%2C%20lone%20detective%20silhouette%20standing%20in%20the%20doorway%2C%20charcoal%20black%20background%2C%20dramatic%20red%20rim%20light%2C%20film%20grain%2C%20high%20contrast%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20still%20of%20an%20empty%20night%20train%20carriage%20with%20deep%20red%20emergency%20lighting%2C%20rain%20streaks%20on%20windows%2C%20long%20perspective%20corridor%2C%20moody%20charcoal%20shadows%2C%20anamorphic%20film%20look%2C%20atmospheric%20haze%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=chikan-backdrop-01&orientation=landscape",
    featured: true,
  },
  {
    id: "carriage-seven",
    title: "第七节车厢",
    type: "tv",
    year: 2025,
    region: "日本",
    duration: "全 12 集",
    director: "冴岛久志",
    cast: ["小野寺凛", "津岛慎一", "白石真央", "安藤圭"],
    genres: ["悬疑", "剧情", "群像"],
    rating: 8.9,
    heat: 10240,
    updatedAt: "2026-10-06",
    tagline: "每晚同一时间，第七节车厢都会多出一名乘客。",
    synopsis:
      "地方线列车第七节车厢接连发生纠纷报案，年轻的车站值班员与退休乘警联手追查，却发现所有线索都指向二十年前的一桩旧案。",
    plot:
      "小野寺凛是地方铁路线上最年轻的值班员。她注意到一个奇怪的规律：最近三个月，第七节车厢在晚上九点零七分发车后，总会发生类似的乘客纠纷，而报案的乘客名单里，总有一个名字对不上任何购票记录。\n\n在退休乘警津岛慎一的帮助下，她开始翻阅旧档案，发现这条线路在二十年前曾发生过一起无人认领的失踪案。随着调查深入，车上的常客一个个浮出水面：深夜通勤的护士、每天坐完全程才下车的少年、总在写同一封信的老人。他们各自守着一段与那趟列车有关的秘密。\n\n十二集的篇幅里，剧集用每一集一位乘客的方式慢慢拼出真相，把一列普通的地方线列车拍成了城市的缩影。结尾并未给出简单的对错，而是把镜头留在清晨第一班车的车门口。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20series%20poster%20of%20a%20narrow%20train%20corridor%20with%20numbered%20carriage%20door%2C%20warm%20amber%20ceiling%20lights%20against%20deep%20crimson%20shadows%2C%20several%20anonymous%20silhouettes%20seen%20from%20behind%2C%20charcoal%20black%20background%2C%20film%20grain%2C%20mysterious%20atmosphere%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20train%20platform%20at%20night%20with%20deep%20red%20signal%20lights%2C%20wet%20asphalt%20reflections%2C%20distant%20silhouette%20of%20a%20conductor%2C%20moody%20dark%20charcoal%20tones%2C%20volumetric%20haze%2C%20anamorphic%20lens%20flare%2C%20no%20text&width=1600&height=900&seq=chikan-backdrop-02&orientation=landscape",
    featured: true,
  },
  {
    id: "platform-zero",
    title: "零号站台",
    type: "movie",
    year: 2026,
    region: "日本",
    duration: "115 分钟",
    director: "桐生一辉",
    cast: ["绪方启", "雨宫千寻", "松冈亮"],
    genres: ["悬疑", "科幻", "犯罪"],
    rating: 8.7,
    heat: 11360,
    updatedAt: "2026-10-12",
    tagline: "不在时刻表上的站台，只在有人需要消失时出现。",
    synopsis:
      "地铁调度员发现系统里多出一条不存在的轨道，每逢雨夜便有列车驶向零号站台。为了寻找失踪的妹妹，他决定登上那班车。",
    plot:
      "调度员绪方启在例行检修时，发现控制台上多出一段无法删除的旧代码。代码指向一条早已废弃的支线，终点标注为「零号站台」。同事告诉他那只是系统残留，可每当雨夜十一点，监控里总会出现一列车灯昏黄的列车。\n\n三年前，绪方的妹妹在同一线路失踪，案件至今未结。他带着录音设备登上那班车，发现车厢里坐着的都是城市里「被遗忘的人」：注销了户籍的流浪者、辞职后人间蒸发的上班族、以及一位自称在等三十年前那班车的老人。\n\n影片把悬疑与温柔并置，用一趟不存在的地铁讨论记忆与告别。当绪方终于站在零号站台上，他必须决定是带妹妹回家，还是让这趟车继续载走那些无处可去的人。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20poster%2C%20abandoned%20subway%20platform%20with%20a%20crimson%20glowing%20number%20zero%20sign%2C%20a%20single%20man%20with%20a%20flashlight%20standing%20at%20the%20platform%20edge%2C%20thick%20fog%2C%20deep%20charcoal%20black%20palette%20with%20red%20highlights%2C%20film%20grain%2C%20dramatic%20contrast%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20abandoned%20underground%20platform%20filled%20with%20fog%20and%20crimson%20red%20glow%2C%20old%20tiled%20walls%2C%20a%20single%20flickering%20lamp%2C%20empty%20tracks%20leading%20into%20darkness%2C%20atmospheric%20mystery%20film%20still%2C%20no%20text&width=1600&height=900&seq=chikan-backdrop-03&orientation=landscape",
    featured: true,
  },
  {
    id: "final-arrival",
    title: "终点站之前",
    type: "movie",
    year: 2024,
    region: "日本",
    duration: "121 分钟",
    director: "南云遥",
    cast: ["神谷透", "三浦沙耶", "大西健"],
    genres: ["剧情", "悬疑", "人文"],
    rating: 8.8,
    heat: 8940,
    updatedAt: "2026-09-19",
    tagline: "列车到站前，他还有四十分钟说出那句道歉。",
    synopsis:
      "一名即将退休的老司机在最后一趟车程中，发现车厢里坐着他二十年前事故中的幸存者。他决定在终点站之前，把真相讲完。",
    plot:
      "神谷透开了三十七年列车，最后一趟班次是深夜的环线。发车前，他在后视镜里认出一张熟悉的脸——那是二十年前一场脱轨事故中唯一的少年幸存者，如今已经三十多岁，沉默地坐在第三节车厢靠窗的位置。\n\n那场事故被定性为设备故障，但神谷知道真正的原因是自己在发车前忽略了异常震动。退休前的四十分钟里，他反复起身又坐下，最终提着保温壶走到那名乘客面前，以一个陌生老人的身份开始攀谈。\n\n影片几乎没有离开过车厢，靠窗外的城市灯带与两人的对话推进。终点站的广播响起时，真相是否说出口已经不再重要，重要的是有人终于愿意听完。",
    poster:
      "https://readdy.ai/api/search-image?query=melancholic%20cinema%20poster%20of%20an%20elderly%20train%20driver%20seen%20in%20profile%20inside%20a%20dim%20cab%2C%20crimson%20signal%20light%20reflecting%20on%20the%20glass%2C%20night%20city%20bokeh%20outside%2C%20deep%20black%20and%20dark%20red%20palette%2C%20soft%20film%20grain%2C%20quiet%20emotional%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20view%20from%20inside%20a%20train%20driver%20cab%2C%20rain%20on%20windshield%2C%20red%20signal%20lights%20streaking%20past%2C%20dark%20urban%20skyline%2C%20moody%20charcoal%20and%20crimson%20color%20grading%2C%20widescreen%20film%20still%2C%20no%20text&width=1600&height=900&seq=chikan-backdrop-04&orientation=landscape",
    featured: true,
  },
  {
    id: "last-train",
    title: "末班车之后",
    type: "movie",
    year: 2022,
    region: "日本",
    duration: "106 分钟",
    director: "井上原",
    cast: ["相叶修", "川岛玲", "藤堂真"],
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    heat: 8170,
    updatedAt: "2026-08-30",
    tagline: "错过了末班车的人，会在这座城市里遇到另一个自己。",
    synopsis:
      "四名错过末班车的陌生人被困在封闭车站，他们发现彼此的手机里都存着同一段举报视频。谁拍的，谁删的，谁在说谎。",
    plot:
      "凌晨零点十二分，四名乘客因为不同的原因错过了末班车，被站务员安置在候车室等待清晨第一班车。闲谈中，其中一人的手机意外播放出一段偷拍视频——正是三天前在车厢里发生的一起骚扰事件。\n\n令人不安的是，另外三个人的手机里也有同一段视频，只是拍摄角度不同、时长不同，甚至有一份被剪辑过。四个互不相识的人开始互相试探，试图弄清谁在传播、谁在删除、谁才是那个真正站在现场却假装旁观的人。\n\n影片用封闭空间和大量对话完成叙事，最后十五分钟的反转并不依赖巧合，而是回到每个人最初那句无关紧要的谎话上。",
    poster:
      "https://readdy.ai/api/search-image?query=tense%20thriller%20movie%20poster%2C%20four%20strangers%20seated%20apart%20in%20a%20closed%20station%20waiting%20room%2C%20harsh%20red%20vending%20machine%20glow%2C%20empty%20ticket%20gate%20behind%20them%2C%20dark%20charcoal%20shadows%2C%20cold%20moody%20atmosphere%2C%20cinematic%20grain%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-05&orientation=portrait",
    featured: false,
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    type: "movie",
    year: 2021,
    region: "韩国",
    duration: "124 分钟",
    director: "朴度贤",
    cast: ["李在勋", "尹素妍", "崔敏浩"],
    genres: ["犯罪", "悬疑", "法庭"],
    rating: 8.4,
    heat: 7620,
    updatedAt: "2026-07-22",
    tagline: "一段没有声音的监控，改变了整个庭审。",
    synopsis:
      "辩护律师在性骚扰案件中接手了一桩几乎必败的案子，唯一的证据是一段没有音频的车厢监控。他决定从每个乘客的站姿里找出真相。",
    plot:
      "律师李在勋一向不接敏感案件，直到事务所把一桩几乎无人愿意辩护的案子推到他手上。被告是地铁检修员，被指控在拥挤车厢中骚扰乘客，唯一的物证是一段没有声音、角度刁钻的监控录像。\n\n所有人都劝他尽早认罪换取轻判，但李在勋在逐帧观看监控时发现，被告的手臂在关键时刻被另一名乘客挡住，而那名乘客的证词前后矛盾。他开始寻找当晚同车厢的乘客，一家一家敲门，一次次被拒绝。\n\n法庭戏占全片四十分钟，没有戏剧化的咆哮，只有冷静的证据推演。当最终画面被放慢到八分之一速，观众与陪审员一起看见了那个被忽略三秒钟的动作。",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20legal%20thriller%20poster%2C%20a%20lawyer%20silhouette%20holding%20case%20files%20in%20a%20dark%20courtroom%2C%20crimson%20red%20exit%20sign%20glow%2C%20blurred%20train%20window%20reflection%20behind%2C%20charcoal%20black%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20film%20grain%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-06&orientation=portrait",
    featured: false,
  },
  {
    id: "red-route",
    title: "赤色路线",
    type: "movie",
    year: 2020,
    region: "中国香港",
    duration: "109 分钟",
    director: "冯世昌",
    cast: ["陈启明", "何嘉欣", "麦子豪"],
    genres: ["犯罪", "动作", "悬疑"],
    rating: 7.8,
    heat: 6340,
    updatedAt: "2026-06-15",
    tagline: "整条线都是他的路线，整座城都在替他遮掩。",
    synopsis:
      "重案组督察追查一连串发生在夜间巴士与地铁上的骚扰案，线索却始终被内部人提前一步抹掉。他怀疑，保护者就在警队里。",
    plot:
      "重案组督察陈启明接手一系列发生在夜间公共交通上的骚扰案。奇怪的是，每次他锁定嫌疑人，对方都会在拘捕前消失，关键监控也总会「恰好」损坏。\n\n调查把他引向一条贯穿全城的赤色巴士路线。司机、清洁工、便利店店员，所有人都知道些什么，却没有人愿意开口。随着一名目击者意外坠楼，陈启明意识到自己追查的不只是一个人，而是一张保护网。\n\n动作场面集中在两场夜戏：一场在停运的地铁维修通道，一场在暴雨中的双层巴士顶层。港式类型片的手感与对社会议题的关注在这部作品里罕见地达成平衡。",
    poster:
      "https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20poster%2C%20rainy%20night%20double%20decker%20bus%20seen%20from%20below%2C%20red%20tail%20lights%20reflecting%20on%20wet%20street%2C%20lone%20detective%20under%20an%20umbrella%2C%20dark%20charcoal%20sky%2C%20neon%20crimson%20accents%2C%20gritty%20cinematic%20grain%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-07&orientation=portrait",
    featured: false,
  },
  {
    id: "end-of-track",
    title: "轨道尽头的光",
    type: "tv",
    year: 2023,
    region: "日本",
    duration: "全 10 集",
    director: "长谷川京",
    cast: ["石田悠", "木村彩", "中川原"],
    genres: ["剧情", "悬疑", "治愈"],
    rating: 8.1,
    heat: 6890,
    updatedAt: "2026-06-02",
    tagline: "被废弃的支线尽头，开着一家只接待乘客的小食堂。",
    synopsis:
      "一名因事故离开一线的女驾驶员，被调往废弃支线尽头的小站。她在这里遇到形形色色的乘客，也慢慢拼回自己的生活。",
    plot:
      "木村彩曾是最被看好的年轻女驾驶员，一场没有伤亡的急停事故让她主动申请调离一线。她被分配到一条即将停运的支线尽头，那里只有一间小食堂和一位沉默的站长。\n\n每一集都有一位特别的乘客来到小站：带着骨灰盒旅行的中年男人、逃课来看最后一班车的高中生、每天写投诉信却从不寄出的老太太。彩在为他们准备一碗热汤的同时，也逐渐说出自己那天为什么按下急停按钮。\n\n剧集节奏舒缓，画面里始终有暖色的灯和远处的轨道反光。第十集结尾，停运列车最后一次通过小站，彩站在月台上敬了一个标准的礼。",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20melancholic%20series%20poster%20of%20a%20tiny%20railway%20station%20at%20dusk%2C%20orange%20lamp%20glow%20inside%20a%20small%20diner%2C%20single%20rail%20track%20leading%20into%20deep%20charcoal%20darkness%2C%20distant%20red%20signal%2C%20soft%20film%20grain%2C%20quiet%20cinematic%20mood%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-08&orientation=portrait",
    featured: false,
  },
  {
    id: "night-loop",
    title: "夜行环线",
    type: "tv",
    year: 2024,
    region: "中国台湾",
    duration: "全 8 集",
    director: "陈昱安",
    cast: ["许承翰", "林知微", "黄士豪"],
    genres: ["悬疑", "心理", "剧情"],
    rating: 8.3,
    heat: 7180,
    updatedAt: "2026-05-27",
    tagline: "他每天坐同一班环线，直到有一天，车厢里多了一个不该存在的人。",
    synopsis:
      "失眠的摄影师每晚乘坐末班环线寻找灵感，却在同一节车厢反复遇见一名女子。当他试图搭话，所有人都说那节车厢早已停用。",
    plot:
      "摄影师许承翰长期失眠，习惯在深夜搭上环线，一圈又一圈地坐到天亮。某晚，他在第五节车厢遇见一名穿米色风衣的女子，两人有过一段短暂而真实的对话。第二天他想再找她，却发现第五节车厢因为检修已经封闭了三个月。\n\n他不信邪地反复乘坐，监控里始终只有他一个人。剧集在他与心理医生的对话、以及车厢内外的时空错位之间来回切换，逐渐揭示那场发生在两年前的列车火灾，以及他作为唯一目击者却选择沉默的那个夜晚。\n\n八集的体量让悬念收放得当，最后一集用同一个镜头角度完成了首尾呼应，是近年台湾悬疑剧里相当扎实的一部。",
    poster:
      "https://readdy.ai/api/search-image?query=psychological%20mystery%20series%20poster%2C%20empty%20metro%20carriage%20interior%20repeating%20into%20infinity%20through%20windows%2C%20a%20woman%20in%20a%20beige%20coat%20seen%20as%20a%20distant%20blur%2C%20deep%20crimson%20ceiling%20light%2C%20charcoal%20dark%20tones%2C%20film%20grain%2C%20dreamlike%20atmosphere%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-09&orientation=portrait",
    featured: false,
  },
  {
    id: "under-the-lamp",
    title: "灯下的证言",
    type: "movie",
    year: 2019,
    region: "日本",
    duration: "97 分钟",
    director: "若林誠",
    cast: ["坂口直人", "杉本千夏"],
    genres: ["剧情", "悬疑"],
    rating: 7.6,
    heat: 4980,
    updatedAt: "2026-04-18",
    tagline: "站台灯灭了七秒，所有证词都从这七秒开始分岔。",
    synopsis:
      "一起发生在站台灯熄灭七秒内的事件，让三名目击者给出了三种完全不同的证词。调查员必须在记忆与立场之间找出真相。",
    plot:
      "老旧的郊区站台因为线路故障，灯光熄灭了七秒。灯亮之后，一名乘客倒在长椅旁，随身物品散落一地。三名目击者分别给出了细节完全冲突的证词：有人说凶手向出口跑去，有人说他跳下了轨道，还有人坚持那七秒里根本没有第三个人。\n\n调查员坂口直人发现，三人的陈述虽然矛盾，但都符合他们各自的视线位置与心理状态。影片用三次重演同一段七秒的方式，让观众看到记忆如何被立场篡改。\n\n这是一部靠剧本和表演取胜的低成本作品，几乎全部场景都在一个站台完成，却拍出了极强的悬念密度。",
    poster:
      "https://readdy.ai/api/search-image?query=minimal%20suspense%20poster%20of%20an%20old%20suburban%20platform%20under%20a%20single%20flickering%20lamp%2C%20deep%20shadows%20with%20a%20crimson%20red%20glow%2C%20scattered%20belongings%20on%20the%20bench%2C%20empty%20dark%20tracks%2C%20charcoal%20palette%2C%20cinematic%20grain%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-10&orientation=portrait",
    featured: false,
  },
  {
    id: "crimson-timetable",
    title: "血色时刻表",
    type: "movie",
    year: 2021,
    region: "日本",
    duration: "104 分钟",
    director: "真木隆",
    cast: ["江口洋介", "藤井美穗", "小坂大地"],
    genres: ["犯罪", "悬疑", "动作"],
    rating: 7.9,
    heat: 5660,
    updatedAt: "2026-04-05",
    tagline: "每一班车都准时，只有死亡没有。",
    synopsis:
      "一张被涂改的列车时刻表成为连环案件的关键，刑警必须在下一班车到站前破解它的规律。",
    plot:
      "连续三周，每隔七天，都有一名乘客在夜间列车上失踪，而每一次的时间都精确对应时刻表上被红色笔迹圈出的一格。刑警江口洋介从一名失踪者的储物柜里找到半张被涂改的时刻表。\n\n随着调查，他发现这些失踪者都曾在同一家劳务派遣公司工作，而那家公司的班车调度系统早已被外部接管。凶手用列车的节奏布置了一场关于「准时」的审判。\n\n影片在时刻表与车厢之间来回剪辑，最后一场戏发生在即将发车的终点站，倒计时的压迫感让整部作品保持着紧张的呼吸。",
    poster:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20poster%20featuring%20a%20blood%20red%20vintage%20timetable%20pinned%20to%20a%20dark%20wall%2C%20faint%20train%20window%20silhouette%20reflection%2C%20deep%20charcoal%20black%20background%2C%20dramatic%20crimson%20lighting%20accents%2C%20high%20contrast%20cinematic%20grain%2C%20vertical%20poster%20layout%2C%20no%20text&width=600&height=900&seq=chikan-poster-11&orientation=portrait",
    featured: false,
  },
  {
    id: "glass-window",
    title: "玻璃车窗",
    type: "movie",
    year: 2018,
    region: "韩国",
    duration: "101 分钟",
    director: "郑河那",
    cast: ["韩志勋", "朴恩书", "文太均"],
    genres: ["剧情", "悬疑", "社会派"],
    rating: 7.5,
    heat: 4320,
    updatedAt: "2026-03-21",
    tagline: "车窗映出的不是夜景，是每个人都不愿承认的旁观。",
    synopsis:
      "一名夜班清洁工在末班车厢里目睹一场纠纷，却因为身份与害怕而选择沉默。第二天，那段画面开始在整座城市里散播。",
    plot:
      "清洁工韩志勋常年在末班车结束后打扫车厢。某个深夜，他在清洁途中目睹两名乘客发生激烈纠纷，其中一人明显处于弱势。他下意识退到了车厢连接处，没有出声。\n\n第二天，一段断章取义的视频在网络流传，被指认为施暴者的其实是无辜者，而真正的旁观者却成了「见义勇为」的主角。韩志勋想开口澄清，却发现自己一旦露面，就可能丢掉工作、暴露逾期居留的身份。\n\n影片以清洁工的视角观察城市的地下空间，用大量玻璃反光镜头强调「看见」与「装作没看见」之间的距离。",
    poster:
      "https://readdy.ai/api/search-image?query=quiet%20Korean%20drama%20poster%2C%20reflection%20of%20a%20lone%20night%20cleaner%20in%20a%20black%20train%20window%2C%20empty%20carriage%20behind%20him%2C%20deep%20crimson%20red%20seat%20fabric%20glow%2C%20muted%20charcoal%20gray%20tones%2C%20soft%20film%20grain%2C%20contemplative%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-12&orientation=portrait",
    featured: false,
  },
  {
    id: "crowded-silence",
    title: "拥挤的沉默",
    type: "tv",
    year: 2026,
    region: "日本",
    duration: "全 9 集",
    director: "宫坂拓真",
    cast: ["斋藤枫", "仲村美沙子", "品川彻"],
    genres: ["社会派", "剧情", "悬疑"],
    rating: 8.5,
    heat: 9360,
    updatedAt: "2026-10-09",
    tagline: "九集，九个乘客，一节从来没有空过的车厢。",
    synopsis:
      "以早高峰电车为舞台的单元剧，每集聚焦一位乘客，用九个普通人的选择拼出一起被忽略的公共事件的全貌。",
    plot:
      "早高峰的环状线，永远拥挤，永远没有人抬头。剧集用九个独立又互相咬合的故事，观察同一节车厢里的一天：赶着面试的毕业生、抱着孩子的母亲、在车厢里补觉的急诊医生、偷偷哭泣的中年上班族。\n\n第九集回到事件本身——一名乘客在人群中求救，却没有一个人按下紧急通话按钮。九个故事在此刻交汇，每集出现过的角色都站在自己的位置上，观众第一次看清了那节车厢的全貌。\n\n剧集没有反派，也没有英雄，只有一连串可以按下却没有按下的按钮。这种克制让它在同类题材里显得格外锋利。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20social%20drama%20poster%2C%20packed%20morning%20commuter%20train%20carriage%20seen%20through%20glass%2C%20faceless%20crowd%20silhouettes%20layered%20in%20deep%20crimson%20and%20charcoal%20shadow%2C%20overhead%20strap%20handles%2C%20film%20grain%2C%20high%20contrast%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-13&orientation=portrait",
    featured: false,
  },
  {
    id: "tunnel-echo",
    title: "隧道回声",
    type: "movie",
    year: 2023,
    region: "中国香港",
    duration: "112 分钟",
    director: "梁志远",
    cast: ["张家伟", "邵美琳", "杜子谦"],
    genres: ["悬疑", "犯罪", "心理"],
    rating: 7.9,
    heat: 5870,
    updatedAt: "2026-03-08",
    tagline: "隧道里传来的呼救声，只有他一个人听得见。",
    synopsis:
      "隧道维修员在深夜值班时听见求救声，报警后却查无此事。为了证明自己没有听错，他开始独自调查这条隧道的过去。",
    plot:
      "隧道维修员张家伟在凌晨的值班室里听见微弱的求救声，声音来自封闭的维修通道。他报警后，警方搜索了整条隧道，没有发现任何人。所有人都认为他压力太大出现了幻听。\n\n他不甘心，开始查阅隧道的施工档案，发现十年前有一名工人在这里失踪，档案被草草结案。随着他越走越深，隧道内的回声开始出现规律，像某种被按下的录音循环。\n\n影片几乎全程使用低频音效与环境噪音制造压迫感，最终的真相既不是灵异也不是巧合，而是一个被工程进度掩盖的沉默决定。",
    poster:
      "https://readdy.ai/api/search-image?query=dark%20psychological%20thriller%20poster%2C%20long%20subway%20tunnel%20with%20red%20maintenance%20lights%20and%20water%20on%20the%20ground%2C%20small%20worker%20figure%20holding%20a%20torch%2C%20deep%20charcoal%20black%20gradient%2C%20dense%20atmospheric%20fog%2C%20cinematic%20film%20grain%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-14&orientation=portrait",
    featured: false,
  },
  {
    id: "the-conductor",
    title: "列车长的笔记",
    type: "tv",
    year: 2022,
    region: "日本",
    duration: "全 11 集",
    director: "小柳徹",
    cast: ["大泽隆志", "桥本奈绪", "石黑修"],
    genres: ["悬疑", "剧情", "职场"],
    rating: 8.0,
    heat: 6010,
    updatedAt: "2026-02-19",
    tagline: "一本写了三十年的值乘笔记，记录着每节车厢的秘密。",
    synopsis:
      "即将退休的列车长留下十一本值乘笔记，新来的见习乘务员从里面读出了一连串被时间掩埋的故事。",
    plot:
      "见习乘务员桥本奈绪在整理储物间时，发现十一本手写笔记，作者是即将退休的列车长大泽隆志。笔记里没有故障记录，全是乘客：哪位老人每周三去墓园、哪个学生总在第七节车厢写作业、哪对情侣在终点站分手。\n\n随着桥本一页页读下去，她发现笔记里反复出现一个日期与同一节车间编号，而那天正是一起至今未破的失踪案发生的日子。她开始按照笔记的线索寻找当年的乘客。\n\n十一集对应十一本笔记，结构精巧，每一集都以一次发车广播开场，把日常与悬念缝合得极其自然。",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20series%20poster%2C%20worn%20leather%20notebook%20open%20on%20a%20conductor%20desk%2C%20brass%20whistle%20and%20old%20timetable%2C%20warm%20crimson%20lamp%20light%20in%20a%20dark%20cabin%2C%20charcoal%20shadows%2C%20nostalgic%20film%20grain%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-15&orientation=portrait",
    featured: false,
  },
  {
    id: "lines-of-dawn",
    title: "破晓线路",
    type: "tv",
    year: 2021,
    region: "日本",
    duration: "全 12 集",
    director: "深津原",
    cast: ["高桥一生", "宫田纱英", "松本航"],
    genres: ["剧情", "悬疑", "青春"],
    rating: 7.7,
    heat: 5120,
    updatedAt: "2026-01-30",
    tagline: "每天清晨五点零五分，这班车只为一个约定发车。",
    synopsis:
      "一条即将停运的清晨线路，连接着六位乘客各自未完成的心愿。列车员决定在停运前，为他们各开一次「专属班次」。",
    plot:
      "清晨五点零五分发车的支线只有六名固定乘客，线路即将在三个月后停运。年轻的列车员宫田纱英翻看意见簿，发现每个人都在上面写过同一个愿望：希望这班车再开久一点。\n\n她向公司申请了六次特别的加开班次，每一次只为一位乘客。有人想再坐一次去上学的路，有人想把这趟车当作婚礼的起点，也有人只是想在终点站把一封信投进邮筒。\n\n十二集的篇幅温柔而克制，没有强行煽情，最后停运当天的长镜头从车头一路摇到车尾，六个人坐在各自的位置上，谁也没有说话。",
    poster:
      "https://readdy.ai/api/search-image?query=hopeful%20cinematic%20poster%20of%20a%20small%20commuter%20train%20at%20dawn%2C%20pale%20amber%20sunrise%20breaking%20through%20deep%20charcoal%20sky%2C%20warm%20red%20tail%20lights%2C%20empty%20platform%20with%20a%20single%20attendant%2C%20soft%20film%20grain%2C%20quiet%20melancholic%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-16&orientation=portrait",
    featured: false,
  },
  {
    id: "empty-seat",
    title: "空座位",
    type: "movie",
    year: 2016,
    region: "中国台湾",
    duration: "96 分钟",
    director: "吴念真司",
    cast: ["杨博文", "谢雨柔", "林道远"],
    genres: ["剧情", "悬疑", "家庭"],
    rating: 7.1,
    heat: 3210,
    updatedAt: "2025-12-14",
    tagline: "父亲每天为同一个人留座，直到那个座位真的有人坐下。",
    synopsis:
      "一名失智老人每天在区间车上为一个不存在的人留座，女儿跟随他重复这趟旅程，才慢慢拼出父亲藏了四十年的秘密。",
    plot:
      "父亲被诊断出轻度失智后，仍坚持每天搭同一班区间车，并且总把靠窗的位置空出来，谁坐他就和人争执。女儿谢雨柔只好请假陪他，一趟一趟地坐完全程。\n\n她以为那是病情造成的固执，直到某天，真的有人坐进了那个位置，而父亲平静地叫出了一个她从没听过的名字。顺着这个名字，她找到一张旧车票与一封未寄出的信，也找到了父亲年轻时离开的另一个家。\n\n影片节奏缓慢，大量使用自然光与车厢内的真实环境音，把一段家庭史安放在一条普通的区间线里。",
    poster:
      "https://readdy.ai/api/search-image?query=intimate%20family%20drama%20poster%2C%20elderly%20man%20seated%20by%20an%20empty%20window%20seat%20in%20a%20local%20train%2C%20warm%20afternoon%20light%20through%20dusty%20glass%2C%20deep%20charcoal%20shadows%20with%20muted%20crimson%20seat%20fabric%2C%20soft%20film%20grain%2C%20quiet%20nostalgic%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-17&orientation=portrait",
    featured: false,
  },
  {
    id: "lost-umbrella",
    title: "遗失的雨伞",
    type: "movie",
    year: 2017,
    region: "日本",
    duration: "93 分钟",
    director: "高濑昌史",
    cast: ["矢野凉", "比嘉奈奈", "冈田诚"],
    genres: ["剧情", "悬疑", "爱情"],
    rating: 7.3,
    heat: 3640,
    updatedAt: "2025-11-26",
    tagline: "一把被拿错的伞，替两个人保管了六年的秘密。",
    synopsis:
      "雨夜的电车上，两个人拿错了彼此的伞。第二天，其中一人在伞柄里发现一张写着地址的纸条，从此开始了一场没有署名的通信。",
    plot:
      "雨夜的电车到站时，矢野凉拿走了一把不是自己的伞。回到家他才发现伞柄里塞着一张折叠的纸条，上面写着一行地址和一句「如果你看到这个，请替我回一封信」。\n\n他按地址寄出一封短信，收到的回信却来自一个从未见过面的女孩。两人开始用信件往来，谈天气、谈书、谈各自的失败，却始终没有交换真实姓名与联系方式。\n\n六年后的同一场雨夜，两人在同一列电车上再次擦肩而过。影片没有给观众一个传统意义上的重逢，只留下车窗上两片重叠的水痕。",
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20melancholic%20movie%20poster%2C%20two%20transparent%20umbrellas%20left%20on%20an%20empty%20train%20seat%2C%20rain%20streaked%20windows%20with%20red%20city%20lights%20outside%2C%20deep%20charcoal%20blue%20black%20mood%20with%20warm%20crimson%20accents%2C%20soft%20film%20grain%2C%20delicate%20atmosphere%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-18&orientation=portrait",
    featured: false,
  },
  {
    id: "red-signal",
    title: "红色信号",
    type: "movie",
    year: 2025,
    region: "韩国",
    duration: "118 分钟",
    director: "姜允宰",
    cast: ["郑宇成", "金多熙", "孙贤宇"],
    genres: ["犯罪", "悬疑", "惊悚"],
    rating: 8.4,
    heat: 8760,
    updatedAt: "2026-10-02",
    tagline: "信号转红的三秒钟里，他必须做出选择。",
    synopsis:
      "地铁司机在撞上轨道上的可疑物体前紧急制动，事后那段录像却不翼而飞。为了洗清嫌疑，他必须找到那三秒钟的真相。",
    plot:
      "地铁司机郑宇成在清晨第一班车出库后不久，发现轨道上似乎有异物。他在信号转红的瞬间紧急制动，列车在距离物体两米处停下。事后检查却发现，轨道上什么也没有，而车载录像的关键三秒被覆盖。\n\n他被停职调查，媒体开始把他塑造成「受惊过度」的司机。为了自证，他私下调取沿线所有摄像头，发现当天有人在隧道口搬走了一个黑色行李箱。\n\n影片后半段转入公路追逐与地下通道的追踪，节奏凌厉，但真正的高潮是最后那段三秒钟的录像被还原时，观众与主角同时看清了那个挥手的身影。",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20poster%2C%20subway%20driver%20cab%20seen%20from%20behind%2C%20blinding%20crimson%20signal%20light%20flooding%20the%20windshield%2C%20dark%20tunnel%20ahead%2C%20deep%20charcoal%20black%20surroundings%2C%20high%20contrast%20cinematic%20lighting%2C%20film%20grain%2C%20tense%20vertical%20poster%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-19&orientation=portrait",
    featured: false,
  },
  {
    id: "night-shift",
    title: "夜班巡查",
    type: "tv",
    year: 2020,
    region: "日本",
    duration: "全 10 集",
    director: "远藤修平",
    cast: ["加藤大辅", "安藤纱织", "森本海斗"],
    genres: ["悬疑", "职场", "剧情"],
    rating: 7.4,
    heat: 4180,
    updatedAt: "2025-10-21",
    tagline: "夜里两点到四点，这条线归他们管。",
    synopsis:
      "一支夜间巡查小队负责在停运后的地铁里处理各种异常。十集十个夜晚，从遗失物到无法解释的报警电话。",
    plot:
      "夜间巡查小队由四人组成，负责在末班车后到首班车前的四个小时里巡检整条线路。他们的工作听上去枯燥：查照明、清点遗失物、处理醉酒乘客。\n\n剧集用十个夜晚串起这支小队的日常。第一集只是找回一只被遗落的书包，最后一集却牵出一桩被掩盖的施工事故。中间穿插着队员各自的生活：队长的女儿正准备考大学，新人还在适应颠倒的作息。\n\n这部作品最动人的地方在于，它把「夜班」拍成了一种生活状态——城市睡了，但总有人醒着，替所有人看着那些没人愿意看的地方。",
    poster:
      "https://readdy.ai/api/search-image?query=night%20shift%20team%20series%20poster%2C%20two%20workers%20in%20reflective%20vests%20walking%20a%20dark%20subway%20tunnel%2C%20crimson%20red%20maintenance%20lamps%2C%20deep%20charcoal%20black%20shadows%2C%20long%20corridor%20perspective%2C%20industrial%20atmosphere%2C%20cinematic%20film%20grain%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=chikan-poster-20&orientation=portrait",
    featured: false,
  },
  {
    id: "the-witness-car",
    title: "目击者车厢",
    type: "tv",
    year: 2025,
    region: "韩国",
    duration: "全 8 集",
    director: "申美京",
    cast: ["朴河镇", "吴允儿", "李道贤"],
    genres: ["悬疑", "犯罪", "群像"],
    rating: 8.2,
    heat: 7910,
    updatedAt: "2026-09-14",
    tagline: "同一节车厢的六名目击者，六份完全不同的笔录。",
    synopsis:
      "一起发生在车厢里的案件，六名目击者的笔录互相矛盾。负责整理材料的实习生发现，所有人的记忆都被人为引导过。",
    plot:
      "警局实习生吴允儿被安排整理一起案件的目击者笔录。六名乘客的描述在关键细节上全部不同：有人说嫌疑人穿黑色外套，有人说深灰色；有人说车上很挤，有人说几乎没人。\n\n她把六份笔录做成时间轴，发现每一次询问前，都有一位自称「心理辅导志愿者」的人与目击者单独接触过。顺着这条线，她查到一个专门在案发后接触证人的灰色组织。\n\n八集的节奏紧凑，剪辑在六个视角之间反复切换，观众与吴允儿一起逐步辨认哪些记忆是被植入的。最后一集揭晓时，最早那份看似最不可靠的笔录反而是唯一真实的。",
    poster:
      "https://readdy.ai/api/search-image?query=ensemble%20crime%20series%20poster%2C%20six%20witness%20silhouettes%20standing%20in%20a%20dark%20train%20carriage%20lit%20from%20below%20by%20crimson%20red%20light%2C%20blurred%20window%20reflections%2C%20deep%20charcoal%20black%20palette%2C%20high%20contrast%20cinematic%20grain%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-21&orientation=portrait",
    featured: false,
  },
  {
    id: "after-platform",
    title: "站台之外",
    type: "tv",
    year: 2019,
    region: "日本",
    duration: "全 9 集",
    director: "三宅航",
    cast: ["冈本卓", "松井玲奈", "田村亮太"],
    genres: ["剧情", "悬疑", "社会派"],
    rating: 7.2,
    heat: 2980,
    updatedAt: "2025-09-03",
    tagline: "站台的监控拍不到的地方，才是这座城市真正的样子。",
    synopsis:
      "一名站台保安在值班中开始记录那些「没有被拍到的瞬间」，九集故事围绕同一座车站展开，描摹一群边缘人的日常。",
    plot:
      "站台保安冈本卓有一个习惯：把监控拍不到的死角画在笔记本上，标注每天发生的小事。哪一格台阶总有人摔倒，哪根柱子后面常有人躲雨，哪扇门后堆着被丢弃的行李。\n\n九集故事围绕这座车站展开，人物彼此擦肩：在站内过夜的少年、在储物柜里寄存骨灰的女人、每天来送便当却从不进站的老先生。冈本的笔记本成了他们的交集。\n\n剧集没有强烈的悬念，而是用细密的观察建立起一种缓慢的紧张感。最后一集，那本笔记本被留在了失物招领处，没有人来认领。",
    poster:
      "https://readdy.ai/api/search-image?query=understated%20Japanese%20drama%20poster%2C%20station%20security%20guard%20notebook%20and%20pen%20on%20a%20rail%2C%20dim%20platform%20beyond%20with%20faint%20crimson%20red%20signal%20light%2C%20charcoal%20black%20night%20tones%2C%20soft%20film%20grain%2C%20quiet%20observational%20mood%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=900&seq=chikan-poster-22&orientation=portrait",
    featured: false,
  },
];